import { Formik } from "formik";
import React from "react";
import Zod from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { FlexScrollArea, FlexScrollAreaContainer, Form, FormikDescriptionTextField, FormikPhoneField, FormikSingleSelect, FormikTextField, FormikUploadSingleImageWithAvatar, FormikUrlTextField, Stack, SubmittingButton, Typography, } from "../components";
import { availableCountryOptions, } from "./SetUpOrganizationInformationForm";
export const SetUpOrganizationInformationFormModal = ({ onContinue, loading, onLoadImageError, app, overwrite, disableStepIndicator = false, submitType, }) => {
    return (React.createElement(Formik, { initialValues: {
            img: undefined,
            name: "",
            country: "",
            phone: undefined,
            phoneCountryCode: undefined,
            website: undefined,
            description: undefined,
        }, onSubmit: (values) => onContinue(values), validationSchema: toFormikValidationSchema(Zod.object({
            img: Zod.string().optional(),
            name: Zod.string(),
            country: Zod.string(),
            phone: Zod.string().optional(),
            phoneCountryCode: Zod.string().optional(),
            website: Zod.string().optional(),
            description: Zod.string().optional(),
        })), validateOnMount: true }, ({ handleSubmit, isValid }) => {
        return (React.createElement(Form, { sx: {
                background: "inherit",
            } },
            React.createElement(FlexScrollAreaContainer, { height: "100%" },
                React.createElement(FlexScrollArea, { sx: {
                        flexDirection: "column",
                        padding: 4,
                        minHeight: (theme) => theme.spacing(90),
                    }, gap: 4 },
                    React.createElement(Stack, { width: "100%", gap: 4, sx: {
                            background: "inherit",
                        } },
                        React.createElement(Stack, { width: "100%", gap: 2, sx: {
                                background: "inherit",
                            } },
                            !disableStepIndicator && (React.createElement(Typography, { variant: "body3", fontWeight: "regular", textColor: "disabled.onContainer" }, "2/2")),
                            React.createElement(Typography, { variant: "h5", fontWeight: "bold" }, "Let\u2019s Set Up Your Organization"),
                            React.createElement(Typography, { variant: "body1", fontWeight: "regular", textColor: "disabled.onContainer" }, "Fill in your organization details below")),
                        React.createElement(Stack, { gap: 4, sx: {
                                background: "inherit",
                            } },
                            React.createElement(FormikUploadSingleImageWithAvatar, { edit: true, name: "img", uploadLabel: "Company Image", imageType: "company", onLoadImageError: onLoadImageError, app: app, overwrite: overwrite }),
                            React.createElement(FormikTextField, { name: "name", label: "Organization Name", required: true, placeholder: "Enter name", fullWidth: true, disabled: loading, helperText: "This information will be public in the marketplace when you create listings" }),
                            React.createElement(FormikSingleSelect, { edit: true, name: "country", label: "Country", required: true, fullWidth: true, placeholder: "Select", options: availableCountryOptions, disabled: loading, helperText: "Select the country where your main headquarters is located. This will appear on your public profile." }),
                            React.createElement(FormikPhoneField, { edit: true, name: "phone", label: "Organization's\u00A0Phone Number", optional: true, fullWidth: true, disabled: loading, defaultCountryCode: "USA" }),
                            React.createElement(FormikUrlTextField, { edit: true, name: "website", label: "Website", optional: true, fullWidth: true, placeholder: "www.biggeo.com", prefix: "https://", disabled: loading }),
                            React.createElement(FormikDescriptionTextField, { name: "description", disabled: loading, helperText: "This information will be public in the marketplace when you create listings" })))),
                React.createElement(Stack, { sx: {
                        flexDirection: "column",
                        padding: 4,
                    } },
                    React.createElement(SubmittingButton, { type: "saving", _type: submitType, disabled: !isValid || loading, loading: loading, onClick: () => handleSubmit(), fullWidth: true }, "Continue")))));
    }));
};
//# sourceMappingURL=SetUpOrganizationInformationFormModal.js.map